import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Link } from "react-router-dom";

const StatCard = ({ icon: Icon, title, value, arrowColor, link,onclick,setState }) => {
  return (
    <Link to={onclick == 'false' && link} className="block">
      <div className="card bg-white shadow rounded-2xl border-0 hover:shadow-lg transition duration-200 cursor-pointer" onClick={() => {onclick == 'true' && setState(true)}}>
        <div className="card-body p-5">
          <div className="flex justify-between items-center gap-4">
            {/* Left Icon */}
            <div className="bg-gray-100 p-3 rounded-xl">
              <Icon className="w-8 h-8 text-gray-500" />
            </div>
            {/* Right Arrow */}
            <ArrowRightIcon className={`w-6 h-6 ${arrowColor}`} />
          </div>

          {/* Middle Content */}
          <div className="flex-1 mt-4">
            <div className="text-[22px] font-bold text-gray-900">{title}</div>
            <div className="text-sm text-gray-500">{value}</div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default StatCard;
